var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v(_vm._s(_vm.pageTitle))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack()
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { class: _vm.alertClass, attrs: { id: "success-alert" } }, [
            _c("strong", [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "forms-container add_user_forms_container" },
            [
              _c("div", { staticClass: "row no-margin" }, [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "name", placeholder: "Enter Name" },
                      domProps: { value: _vm.name },
                      on: {
                        keydown: function($event) {
                          return _vm.nameKeydown($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.name = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.nameError))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.slug,
                          expression: "slug"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        readonly: "readonly",
                        placeholder: "Enter Slug"
                      },
                      domProps: { value: _vm.slug },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.slug = $event.target.value
                          },
                          function($event) {
                            _vm.slugError = ""
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.slugError))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 input-group" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-7 paddingleft0" },
                    [
                      _c("ejs-colorpicker", {
                        model: {
                          value: _vm.classBackgroundColor,
                          callback: function($$v) {
                            _vm.classBackgroundColor = $$v
                          },
                          expression: "classBackgroundColor"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("ejs-colorpicker", {
                        model: {
                          value: _vm.classTextColor,
                          callback: function($$v) {
                            _vm.classTextColor = $$v
                          },
                          expression: "classTextColor"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row no-margin" },
                [
                  _c("div", { staticClass: "col-12 forms-block" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        on: { click: _vm.addGalleryRow }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-plus",
                          attrs: { "aria-hidden": "false" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("Click to Add More")]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "25px" } }, [
                      _c("span", { staticClass: "help is-danger" }, [
                        _vm._v(_vm._s(_vm.commonGalleryError))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _vm._l(_vm.gallery_inputs, function(input, index) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 forms-block d-flex justify-content-between"
                        },
                        [
                          _c("div", { staticClass: "col-3" }, [
                            _c("div", { staticClass: "col-12 paddingleft0" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-label",
                                  attrs: { slot: "before", for: "Name" },
                                  slot: "before"
                                },
                                [_vm._v("Name :")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 paddingleft0" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: input.name,
                                    expression: "input.name"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { id: "name", placeholder: "Name" },
                                domProps: { value: input.name },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        input,
                                        "name",
                                        $event.target.value
                                      )
                                    },
                                    function($event) {
                                      _vm.commonGalleryError = ""
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "requiredstar" }, [
                                _vm._v("*")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-3" }, [
                            _c("div", { staticClass: "col-12 paddingleft0" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-label",
                                  attrs: { slot: "before", for: "description" },
                                  slot: "before"
                                },
                                [_vm._v("Description :")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 paddingleft0" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: input.description,
                                    expression: "input.description"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "description",
                                  placeholder: "Description"
                                },
                                domProps: { value: input.description },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        input,
                                        "description",
                                        $event.target.value
                                      )
                                    },
                                    function($event) {
                                      _vm.commonGalleryError = ""
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "requiredstar" }, [
                                _vm._v("*")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-4" }, [
                            _c("div", { staticClass: "col-12 paddingleft0" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-label",
                                  attrs: { slot: "before", for: "startDate" },
                                  slot: "before"
                                },
                                [_vm._v("File :")]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-12 paddingleft0" },
                              [
                                _c(
                                  "vue-dropzone",
                                  {
                                    ref: "dropzone_" + index,
                                    refInFor: true,
                                    attrs: {
                                      id: "drop1",
                                      options: _vm.dropzoneOptions,
                                      destroyDropzone: false,
                                      headers: _vm.dropzoneOptions.headers,
                                      name: "file[]"
                                    },
                                    on: {
                                      "vdropzone-total-upload-progress":
                                        _vm.progressOfUload,
                                      "vdropzone-removed-file": function(
                                        $event
                                      ) {
                                        return _vm.removedSelectedFile(index)
                                      },
                                      "vdropzone-success": _vm.vfileSuccess,
                                      "vdropzone-complete": function($event) {
                                        return _vm.afterComplete(index)
                                      },
                                      "vdropzone-duplicate-file":
                                        _vm.vduplicateFile
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dropzone-custom-content"
                                      },
                                      [
                                        _c(
                                          "h4",
                                          {
                                            staticClass: "dropzone-custom-title"
                                          },
                                          [
                                            _vm._v(
                                              "Drop files here or click to upload."
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "subtitle" }, [
                                          _vm._v(
                                            "Select files from your computer."
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "requiredstar" }, [
                                  _vm._v("*")
                                ])
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-1 forms-block" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-danger",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteGalleryRow(index)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-times" })]
                            )
                          ])
                        ]
                      )
                    ]
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-2 forms-block" })
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "button-demo" }, [
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "addBenifitBtn",
                    disabled: _vm.disableButtons.save,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.save },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addUpdateClassMaster()
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "addAndContinueBenifitBtn",
                    disabled: _vm.disableButtons.saveAndContinue,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.saveAndContinue },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.addUpdateClassMaster((_vm.flag = "Save and Continue"))
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "CancelBenifit",
                    disabled: _vm.disableButtons.cancel,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.cancel },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.buttonBack.apply(null, arguments)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.gallery_data.length > 0
                ? [
                    _c("div", { staticClass: "row clearfix" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 forms-block" }),
                    _vm._v(" "),
                    _c("h1", { staticStyle: { "text-align": "center" } }, [
                      _vm._v("Already Uploaded Media")
                    ]),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _vm._l(_vm.gallery_data, function(media, index) {
                      return [
                        _c(
                          "div",
                          { staticClass: "row bulletin-board-listing" },
                          [
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(media.name) +
                                    "\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(media.description) +
                                    " \n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-3" }, [
                              _c(
                                "div",
                                { staticClass: "form-group text-center" },
                                [
                                  media.content_type === "image/jpeg" ||
                                  media.content_type === "image/png" ||
                                  media.content_type === "image/gif"
                                    ? [
                                        _c("img", {
                                          attrs: {
                                            width: "100%",
                                            src: _vm.s3_url + media.path,
                                            alt: "Maia Parsons",
                                            height: "150px;"
                                          }
                                        })
                                      ]
                                    : media.content_type === "video/mp4"
                                    ? [
                                        _c(
                                          "video",
                                          {
                                            attrs: {
                                              width: "100%",
                                              controls: "controls",
                                              preload: "metadata"
                                            }
                                          },
                                          [
                                            media.path != ""
                                              ? [
                                                  _c("source", {
                                                    attrs: {
                                                      src:
                                                        _vm.s3_url +
                                                        media.path +
                                                        "#t=0.5",
                                                      type: "video/mp4"
                                                    }
                                                  })
                                                ]
                                              : [
                                                  _c("source", {
                                                    attrs: {
                                                      src: "",
                                                      type: "video/mp4"
                                                    }
                                                  })
                                                ]
                                          ],
                                          2
                                        )
                                      ]
                                    : [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.s3_url + media.path,
                                              download: ""
                                            }
                                          },
                                          [_vm._v("Download")]
                                        )
                                      ]
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-3" }, [
                              _c(
                                "div",
                                { staticClass: "form-group text-center" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      staticStyle: { "margin-top": "30px" },
                                      attrs: { id: media.id, type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGalleryMedia(
                                            media.id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-minus-circle"
                                      })
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Name :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Slug :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-5 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Background Color :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Text Color :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "form-group bold" }, [
          _vm._v("\n                            Name\n                        ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "form-group bold" }, [
          _vm._v(
            "\n                            Description\n                        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "form-group bold text-center" }, [
          _vm._v(
            "\n                            Media\n                        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "form-group bold text-center" }, [
          _vm._v(
            "\n                            Action\n                        "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20436cd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20436cd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClassMaster/AddUpdateClassMaster.vue
// module id = null
// module chunks = 